import { BASE_URL } from "../lib/base_url";

// const backendUrl = `${BASE_URL}/api/v1`;
const backendUrl = BASE_URL;

export const endpointUrl = {
  getServices: `${backendUrl}/service`,
  getBlogs: `${backendUrl}/blog`,
  geBlogsLength: `${backendUrl}/blog/count`,
  getBlogsBySlug: (title_slug: string) =>
    `${backendUrl}/blog/${title_slug}/title`,
  getBlogById: (id: string) => `${backendUrl}/blog/${id}`,
  createMessage: `${backendUrl}/contactus`,
  getTestimonial: `${backendUrl}/testimonial`,
  getProject: `${backendUrl}/project`,
  getProducts: `${backendUrl}/products/`,
  getProductsById: (id: string) => `${backendUrl}/products/${id}`,
  getProductsByCategory: (category: string) =>
    `${backendUrl}/products/${category}`,
  registerVendor: `${backendUrl}/api/v1/auth/user/signup/`,
  loginVendor: `${backendUrl}/api/v1/auth/user/login/`,
};
